export default "__VITE_ASSET__jIl0G40o__"